import { api } from 'app/utils/api/helpers'

export const sendInviteToApply = (teamGUID, payload) => {
  return api.post(`/sm/teams/${teamGUID}/invitetoapply`, payload)
}
